import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotificationsNoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notifications_none"}/>
}
